import { useEffect, useMemo } from 'react';
import { useUserPreferencesStore } from '../stores/userPreferencesStore';
import { buildMuiTheme } from './index';

/**
 * App-wide MUI theme driven by the saved user preference
 * (Profile → Theme & Display → Theme Mode). Defaults to light until
 * preferences load. The store is zustand-persisted, so returning users get
 * their saved mode immediately on refresh, before the backend fetch resolves.
 *
 * Also stamps `data-theme` on <html> so plain CSS (index.css, legacy
 * component .css files) can carry dark overrides via [data-theme='dark'].
 */
export function useAppTheme() {
  const mode = useUserPreferencesStore((state) =>
    state.preferences?.themeSettings?.mode === 'dark' ? 'dark' : 'light',
  );

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
  }, [mode]);

  return useMemo(() => buildMuiTheme(mode), [mode]);
}
